import { Navigate, Route, Routes } from "react-router-dom";
import routers from "./routers";
import ProtectedRoute from "../components-ui/protected-route";
import { useAuth } from "../hooks/useAuth";

const PrivateContent = () => {
  const { user } = useAuth();
  
  return (
    <>
      <Routes>
        {routers.map((x, idx) => {
          return (
 
            <Route 
              key={idx} 
              path={`${x.path}`} 
              element={
                <ProtectedRoute userMenus={user?.menus || []}>
                  <x.component />
                </ProtectedRoute>
              } 
            />
          );
        })}
        <Route path="*" element={<Navigate to={"/home"} replace />} />
      </Routes>
    </>
  );
};

export default PrivateContent;


// import { Navigate, Route, Routes } from "react-router-dom";


// import routers from "./routers";

// const PrivateContent = () => {

//   const defaultPage = () => {
//     return "/home";
//   };
//   return (
//     <>
//       <Routes>
//         {routers.map((x, idx) => {
//           return <Route key={idx} path={`${x.path}`} Component={x.component} />;
//         })}
//         <Route path="*" element={<Navigate to={"/home"} replace />} />
//       </Routes>
//     </>
//   );
// };

// export default PrivateContent;
